import { Configuration, InsaculacionesApi, SolicitudesApi } from '@conacyt/insaculacion-client';

const insaculacionConfiguration = new Configuration({ basePath: '/services/insaculacionms/api' });

const insaculacionesApi = new InsaculacionesApi(insaculacionConfiguration);
const solicitudesApi = new SolicitudesApi(insaculacionConfiguration);

export { insaculacionesApi, solicitudesApi };
